import React from "react";
import styled from "styled-components";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

const ReactTable3 = ({ data }) => {
  return (
    <TableWrapper>
      <StyledTable>
        <Thead>
          <Tr>
            <StyledTh>No</StyledTh>
            <StyledTh>Ödev Kazanımı</StyledTh>
            <StyledTh>Puanı</StyledTh>
            <StyledTh>Veriliş Tarihi</StyledTh>
            <StyledTh>Bitiş Tarihi</StyledTh>
            <StyledTh>İlerleme Durumu</StyledTh>
          </Tr>
        </Thead>
        <Tbody>
          {data.map((row, index) => (
            <StyledTr key={index}>
              <StyledTd>{row.no}</StyledTd>
              <StyledTd>{row.kazanims}</StyledTd>
              <StyledTd>{row.puan || "-"}</StyledTd>
              <StyledTd>{row.startDate}</StyledTd>
              <StyledTd>{row.endDate}</StyledTd>
              <StyledTd>
                <Status $status={row.durum}>{row.durum}</Status>
              </StyledTd>
            </StyledTr>
          ))}
        </Tbody>
      </StyledTable>
    </TableWrapper>
  );
};

export default ReactTable3;

/* 🔧 Styles */

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-top: 1rem;
`;

const StyledTable = styled(Table)`
  width: 100%;
  font-size: 0.95rem;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    color: var(--main-color);
    border: 4px solid var(--main-color);
    border-radius: 20px;
  }
`;

const StyledTh = styled(Th)`
  background-color: var(--main-color);
  color: #fff;
  text-align: center;
  padding: 12px;
  font-weight: bold;
`;

const StyledTr = styled(Tr)`
  &:nth-child(even) {
    background-color: var(--third-color);
  }
`;

const StyledTd = styled(Td)`
  text-align: center;
  padding: 10px;
  border-bottom: 1px solid #ddd;

  @media (max-width: 768px) {
    text-align: left;
    border-bottom: none;
    padding: 8px;
  }
`;

const Status = styled.span`
  font-weight: bold;
  color: ${({ $status }) =>
    $status === "Tamamlandı" ? "green" : "var(--delete-color)"};
`;
